module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'gsmj2zok',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
